<dynamic-form
  *ngIf="formGroup && formGroupIsOk"
  [apiName]="apiName"
  [group]="formGroup"
  [areaName]="areaName"
  [label]="label"
  [model]="model"
  [columns]="columns"
  [defaultHeight]="25"
  [hasDefault]="false"
  (cancelChange)="cancel()"
  (submitChange)="save()">
  <ng-container class="content">
    <div class="row m-2">
      <div *ngIf="StatusKindIds" class="col-6">
        <ssg-select
          name="StatusKindIds"
          [multiple]="true"
          [group]="formGroup"
          dropdownPosition="auto"
          limitSelection="5"
          userClass="select-md"
          [hasCheckBox]="true"
          [hasSelectAll]="true"
          label="وضعیت سند"
          apiName="Lookup"
          systemName="INV"
          category="StatusKind"
          textFieldName="Title"
          valueFieldName="Id">
        </ssg-select>
      </div>
      <div *ngIf="WarehouseIds" class="col-6">
        <ssg-select
          name="WarehouseIds"
          [multiple]="true"
          userClass="select-md"
          [group]="formGroup"
          dropdownPosition="auto"
          limitSelection="5"
          [hasCheckBox]="true"
          [hasSelectAll]="true"
          label="انبار"
          apiName="Warehouse/ReadLookUp"
          textFieldName="Title"
          valueFieldName="Id">
        </ssg-select>
      </div>
      <div *ngIf="DetailLedgerIds" class="col-6">
        <ssg-select
          name="DetailLedgerIds"
          [multiple]="true"
          [group]="formGroup"
          userClass="select-md"
          dropdownPosition="auto"
          limitSelection="5"
          [hasCheckBox]="true"
          [hasSelectAll]="true"
          label="تفصیلی طرف مقابل"
          apiName="DetailLedger/ReadLookUp"
          textFieldName="Title"
          valueFieldName="Id">
        </ssg-select>
      </div>
      <div *ngIf="ReferenceVoucherKindIds" class="col-6">
        <ssg-select
          name="ReferenceVoucherKindIds"
          [multiple]="true"
          [group]="formGroup"
          userClass="select-md"
          dropdownPosition="auto"
          limitSelection="5"
          [hasCheckBox]="true"
          [hasSelectAll]="true"
          label="نوع سند مبنا"
          apiName="InvVoucherKind/ReadLookUp"
          textFieldName="Title"
          valueFieldName="Id">
        </ssg-select>
      </div>
      <div *ngIf="VoucherKindIds" class="col-6">
        <ssg-select
          name="VoucherKindIds"
          [multiple]="true"
          [group]="formGroup"
          userClass="select-md"
          dropdownPosition="auto"
          limitSelection="5"
          [hasCheckBox]="true"
          [hasSelectAll]="true"
          label="نوع سند"
          apiName="InvVoucherKind/ReadLookUp"
          textFieldName="Title"
          valueFieldName="Id">
        </ssg-select>
      </div>
    </div>
  </ng-container>
</dynamic-form>
